module.exports = __webpack_public_path__ + "img/dunlop-jhw4-‘69-psych-series-band-of-gypsys-fuzz.52018606.jpg";